/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : BillingAddress.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Madhu Gali - H175591
*
* @Date         : Oct 03, 2019
*
* @Version      : Version 1.0
*
 * By            	: Madhu Gali (H175591)
 * On            	: Oct 03, 2019
 * Description        : ASDS-1476
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 * *
 * By            : H422335
 * On            : Oct 08, 2020
 * Description   : ASDS-3512 UI Fixes.
******************************************************************************/
import * as React from 'react';
import {
    Grid,
} from '@scuf/common';

// This function is used to display the component Billing Address
import { IBillingAddressProps } from '../utils/checkout-interfaces';
import ShippingInfoComponent from './ShippingInfoComponent';
import AddressDetails from './AddressDetails';

function BillingAddress(props: IBillingAddressProps) {
    return (
        <React.Fragment>
            <Grid.Row>
                <Grid.Column width={12} className="paddingbottom">
                    <span className="ro-heading-text">Billing Account</span>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={11} className="paddingbottom">
                    <hr className="ro-hr-line" />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <AddressDetails addressDetails={props.addressDetails}>
                    <p className="helpTextItalic">
                        <br />
                    </p>
                </AddressDetails>
            </Grid.Row>
            <ShippingInfoComponent />
        </React.Fragment >
    );
}

export default BillingAddress;